// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 30 hooks for backend/cash.

import { useBackend } from '../useBackend'

/** POST /api/cash/applyReceiptCash */
export function useApplyReceiptCash<T = any>() {
  return useBackend<T>('cash/applyReceiptCash')
}

/** POST /api/cash/attributeBankCredit */
export function useAttributeBankCredit<T = any>() {
  return useBackend<T>('cash/attributeBankCredit')
}

/** POST /api/cash/closeCashItem */
export function useCloseCashItem<T = any>() {
  return useBackend<T>('cash/closeCashItem')
}

/** POST /api/cash/confirmCashDocument */
export function useConfirmCashDocument<T = any>() {
  return useBackend<T>('cash/confirmCashDocument')
}

/** POST /api/cash/getCashByDriver */
export function useGetCashByDriver<T = any>() {
  return useBackend<T>('cash/getCashByDriver')
}

/** POST /api/cash/getCashCoverage */
export function useGetCashCoverage<T = any>() {
  return useBackend<T>('cash/getCashCoverage')
}

/** POST /api/cash/getCashDocumentUrl */
export function useGetCashDocumentUrl<T = any>() {
  return useBackend<T>('cash/getCashDocumentUrl')
}

/** POST /api/cash/getCashDocuments */
export function useGetCashDocuments<T = any>() {
  return useBackend<T>('cash/getCashDocuments')
}

/** POST /api/cash/getCashResolutions */
export function useGetCashResolutions<T = any>() {
  return useBackend<T>('cash/getCashResolutions')
}

/** POST /api/cash/getCashShifts */
export function useGetCashShifts<T = any>() {
  return useBackend<T>('cash/getCashShifts')
}

/** POST /api/cash/getCashSummary */
export function useGetCashSummary<T = any>() {
  return useBackend<T>('cash/getCashSummary')
}

/** POST /api/cash/getDepositBankStatus */
export function useGetDepositBankStatus<T = any>() {
  return useBackend<T>('cash/getDepositBankStatus')
}

/** POST /api/cash/getDepositSlips */
export function useGetDepositSlips<T = any>() {
  return useBackend<T>('cash/getDepositSlips')
}

/** POST /api/cash/getDriverCashOutstanding */
export function useGetDriverCashOutstanding<T = any>() {
  return useBackend<T>('cash/getDriverCashOutstanding')
}

/** POST /api/cash/getDriverCashPosition */
export function useGetDriverCashPosition<T = any>() {
  return useBackend<T>('cash/getDriverCashPosition')
}

/** POST /api/cash/getDriverCreditCandidates */
export function useGetDriverCreditCandidates<T = any>() {
  return useBackend<T>('cash/getDriverCreditCandidates')
}

/** POST /api/cash/getFuelReconciliation */
export function useGetFuelReconciliation<T = any>() {
  return useBackend<T>('cash/getFuelReconciliation')
}

/** POST /api/cash/getFuelStations */
export function useGetFuelStations<T = any>() {
  return useBackend<T>('cash/getFuelStations')
}

/** POST /api/cash/getFuelTransactions */
export function useGetFuelTransactions<T = any>() {
  return useBackend<T>('cash/getFuelTransactions')
}

/** POST /api/cash/getOverDeclaredReceipts */
export function useGetOverDeclaredReceipts<T = any>() {
  return useBackend<T>('cash/getOverDeclaredReceipts')
}

/** POST /api/cash/getReceiptReadings */
export function useGetReceiptReadings<T = any>() {
  return useBackend<T>('cash/getReceiptReadings')
}

/** POST /api/cash/ingestFuelReport */
export function useIngestFuelReport<T = any>() {
  return useBackend<T>('cash/ingestFuelReport')
}

/** POST /api/cash/linkCashDocument */
export function useLinkCashDocument<T = any>() {
  return useBackend<T>('cash/linkCashDocument')
}

/** POST /api/cash/readShiftDocuments */
export function useReadShiftDocuments<T = any>() {
  return useBackend<T>('cash/readShiftDocuments')
}

/** POST /api/cash/recordCashResolution */
export function useRecordCashResolution<T = any>() {
  return useBackend<T>('cash/recordCashResolution')
}

/** POST /api/cash/rejectCashDocument */
export function useRejectCashDocument<T = any>() {
  return useBackend<T>('cash/rejectCashDocument')
}

/** POST /api/cash/setStationLocation */
export function useSetStationLocation<T = any>() {
  return useBackend<T>('cash/setStationLocation')
}

/** POST /api/cash/unattributeBankCredit */
export function useUnattributeBankCredit<T = any>() {
  return useBackend<T>('cash/unattributeBankCredit')
}

/** POST /api/cash/uploadCashDocument */
export function useUploadCashDocument<T = any>() {
  return useBackend<T>('cash/uploadCashDocument')
}

/** POST /api/cash/withdrawCashItemClosure */
export function useWithdrawCashItemClosure<T = any>() {
  return useBackend<T>('cash/withdrawCashItemClosure')
}
